import { Carousel } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import Calculation from 'classes/Recipe/Detail/Calculation/Calculation';
import Co2Display from 'components/desktop/_general/Co2Display/Co2Display';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import NutriScoreDiagram from 'components/desktop/_general/NutriScoreDiagram/NutriScoreDiagram';
import PriceDisplay from 'components/desktop/_general/PriceDisplay';
import SeasonalityHistogram from 'components/desktop/_general/SeasonalityHistogram/seasonalityHistogram';
import ENTITLEMENTS from 'enums/entitlements';
import { RootState } from 'reducers/rootReducer';
import { AllergenLight } from 'types/Allergen/AllergenLight';
import { Recipe } from 'types/Recipe/Recipe';
import { Segment } from 'types/Recipe/Segment';
import { TagLight } from 'types/Tag/TagLight';
import { NutriScore } from 'types/_general/NutriScore';

import { IconsBar } from '../IconsBar/IconsBar';

export type IProps = {
	segmentInEntryLanguage: Segment[];
	recipe: Recipe;
	calculation: Calculation | null;
	nutriScore: NutriScore | null;
	allergens?: AllergenLight[];
	tags: TagLight[];
	title?: string;
};

export const RecipeSummary = (props: IProps) => {
	const reduxCurrency: string = useSelector((state: RootState) => state.currency);
	const reduxValueScope = useSelector((state: RootState) => state.valueScope);

	return (
		<div
			style={{
				width: '100%',
				boxSizing: 'border-box',
				whiteSpace: 'nowrap',
				display: 'flex',
				flexDirection: 'column',
				paddingLeft: '1rem',
				paddingTop: '1rem',
			}}
		>
			<div
				style={{
					marginLeft: '-2rem',
					paddingLeft: '3rem',
					paddingRight: '2rem',
					paddingTop: '1rem',
					paddingBottom: '1rem',
					borderRadius: '0 1rem 1rem 0',
					color: 'white',
					backgroundImage: 'linear-gradient(-45deg, #99a1fd 0%, #6066C1 100%)',
					boxShadow: '0 0.2rem 4px 2px rgb(0 0 0 / 8%)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: '1rem',
				}}
			>
				<div
					style={{
						fontSize: '1.2em',
						fontWeight: 'bold',
						width: '50%',
						whiteSpace: 'normal', // allow text to wrap
						wordBreak: 'break-word',
					}}
				>
					{props.title}
				</div>
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: '1rem',
				}}>
					<IconsBar tags={props.recipe.tags} allergens={props.recipe.allergens} />

					<RenderIf entitlements={[ENTITLEMENTS.NUTRI_SCORE]}>
						<NutriScoreDiagram
							nutriScore={props.nutriScore ?? props.recipe.nutriScore ?? null}
						/>
					</RenderIf>
				</div>
			</div>
			<div
				style={{
					marginTop: '1rem',
					padding: '1rem',
					display: 'flex',
					alignItems: 'center',
					overflowX: 'auto', // Enables scroll only when needed
					whiteSpace: 'nowrap',
					width: '100%', // Ensures div does not exceed parent
					boxSizing: 'border-box', // Makes sure padding doesn't exceed width
					justifyContent: 'space-around',
					gap: '1rem',
				}}
			>
				<RenderIf condition={Boolean(props.calculation ?? props.recipe.carbonDioxideValue)}>
					<Co2Display
						value={
							props.calculation?.carbonDioxideValue ?? props.recipe.carbonDioxideValue
						}
						color={
							props.calculation?.carbonDioxideLabel?.color ??
							props.recipe.carbonDioxideLabel?.color ??
							'#000'
						}
						valueScopeInfo={{
							valueScope: reduxValueScope,
							persons: props.recipe.persons,
							parts: props.recipe.parts,
							weight:
								props.calculation?.weight ??
								props.recipe.weight ??
								props.recipe.ingredientWeight,
						}}
					/>
				</RenderIf>
				<RenderIf entitlements={[ENTITLEMENTS.SEASON]}>
					<SeasonalityHistogram
						seasonsHistogram={props.calculation?.seasonsHistogram || {}}
					/>
				</RenderIf>
				<RenderIf
					condition={Boolean(props.calculation ?? props.recipe.price)}
					entitlements={[ENTITLEMENTS.PRICE]}
				>
					<PriceDisplay
						value={props.calculation?.price ?? props.recipe.price ?? null}
						currency={reduxCurrency}
						valueScopeInfo={{
							valueScope: reduxValueScope,
							persons: props.recipe.persons,
							parts: props.recipe.parts,
							weight:
								props.calculation?.weight ??
								props.recipe.weight ??
								props.recipe.ingredientWeight,
						}}
					/>
				</RenderIf>
				{/* <Carousel style={{ minHeight: '8rem',  }}>
				<Carousel.Item>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div style={{ width: '', marginTop: '1rem' }}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								<div style={{ width: '', marginTop: '1rem' }}>
									<RenderIf entitlements={[ENTITLEMENTS.SEASON]}>
										<SeasonalityHistogram
											seasonsHistogram={
												props.calculation?.seasonsHistogram || {}
											}
										/>
									</RenderIf>
								</div>
							</div>
						</div>
					</div>
				</Carousel.Item>

				<Carousel.Item>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div style={{ width: '', marginTop: '1rem' }}>
							<RenderIf entitlements={[ENTITLEMENTS.NUTRI_SCORE]}>
								<NutriScoreDiagram
									nutriScore={props.nutriScore ?? props.recipe.nutriScore ?? null}
								/>
							</RenderIf>
						</div>
					</div>
				</Carousel.Item>

				<Carousel.Item>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div style={{ width: '', marginTop: '1rem' }}>
							<RenderIf
								condition={Boolean(
									props.calculation ?? props.recipe.carbonDioxideValue
								)}
							>
								<Co2Display
									value={
										props.calculation?.carbonDioxideValue ??
										props.recipe.carbonDioxideValue
									}
									color={
										props.calculation?.carbonDioxideLabel?.color ??
										props.recipe.carbonDioxideLabel?.color ??
										'#000'
									}
									valueScopeInfo={{
										valueScope: reduxValueScope,
										persons: props.recipe.persons,
										parts: props.recipe.parts,
										weight:
											props.calculation?.weight ??
											props.recipe.weight ??
											props.recipe.ingredientWeight,
									}}
								/>
							</RenderIf>
						</div>
					</div>
				</Carousel.Item>

				<Carousel.Item>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div style={{ width: '', marginTop: '1rem' }}>
							<RenderIf
								condition={Boolean(props.calculation ?? props.recipe.price)}
								entitlements={[ENTITLEMENTS.PRICE]}
							>
								<PriceDisplay
									value={props.calculation?.price ?? props.recipe.price ?? null}
									currency={reduxCurrency}
									valueScopeInfo={{
										valueScope: reduxValueScope,
										persons: props.recipe.persons,
										parts: props.recipe.parts,
										weight:
											props.calculation?.weight ??
											props.recipe.weight ??
											props.recipe.ingredientWeight,
									}}
								/>
							</RenderIf>
						</div>
					</div>
				</Carousel.Item>
				<Carousel.Item>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div style={{ width: '', marginTop: '2rem' }}>
						<IconsBar tags={props.recipe.tags} allergens={props.recipe.allergens} />
						</div>
					</div>
				</Carousel.Item>
				
			</Carousel> */}
			</div>
		</div>
	);
};
